import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { IconClose, NamedLink } from '../../components';
import css from './FavoritesListCards.module.css';

const FavoritesListCards = props => {
  const {
    currentUser,
    favorites,
    updateExistingList,
    onOpenDeleteListPopup,
    isLinkForSearch,
  } = props;

  const filteredFavorites = favorites.filter(i => i.favoritesListings.length > 0)


  if (isLinkForSearch) {
    return (
      <ul className={css.favoritesListGrid}>
        {filteredFavorites.map(item => {
          const listingId = item?.favoritesListings[0];
          const slug = '';
          return (
            <li key={item.favoritesId} className={css.favoritesListLinkItem}>
              <div className={css.favoritesDelete} onClick={() => onOpenDeleteListPopup(item)}>
                <IconClose />
              </div>
              <NamedLink
                className={css.favoritesListLink}
                name="ListingPage" params={{ id: listingId, slug }}
              >
                <img
                  className={css.favoritesListLinkImage}
                  src={item?.favoritesImage?.[1] || item?.favoritesImage?.[0]}
                  alt={item?.favoritesTitle}
                />
                <h2 className={css.favoritesListLinkTitle}>{item?.favoritesTitle}</h2>
              </NamedLink>
            </li>
          );
        })}
      </ul>
    );
  } else {
    return (
      <ul className={css.favoritesList}>
        {favorites.map(item => {
          return (
            <li
              key={item.favoritesId}
              className={css.favoritesListItem}
              onClick={() => updateExistingList(item.favoritesId)}
            >
              <img
                className={css.favoritesListImage}
                src={item?.favoritesImage?.[1] || item?.favoritesImage?.[0]}
                alt={item?.favoritesTitle}
              />

              <h3 className={css.favoritesListTitle}>{item?.favoritesTitle}</h3>

              <p className={css.favoritesListCounter}>
                <FormattedMessage
                  id="FavoritesPage.addedToFavorite"
                  values={{ counter: item?.favoritesListings?.length }}
                />
              </p>
            </li>
          );
        })}
      </ul>
    );
  }
};

export default FavoritesListCards;
